import React, { useState, useEffect } from "react";

const RCPdf2 = () => {
  const [rcno, setRcno] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfBase64, setPdfBase64] = useState(null);
  const [history, setHistory] = useState([]);

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const downloadPDF = (base64, name) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${name}.pdf`;
    link.click();
  };

  const fetchHistory = async () => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_rc_list2.php?user_id=${user.id}`
      );
      const data = await res.json();
      if (data.status) setHistory(data.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (user?.id) fetchHistory();
  }, []);

  const handleGenerate = async () => {
    if (!rcno) return alert("Enter RC Number");

    setLoading(true);
    setPdfBase64(null);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/generate_rc_pdf.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: user.id,
            rcno: rcno.trim(),
          }),
        }
      );

      const data = await res.json();

      if (data.status) {
        if (data.pdf_base64) setPdfBase64(data.pdf_base64);
        alert(data.duplicate ? "Already exists" : "RC Generated ✅");
        fetchHistory();
      } else {
        alert(data.message);
      }
    } catch {
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: "30px", background: "#f4f6f9", minHeight: "100vh" }}>
      
      {/* 🔥 CARD */}
      <div style={{
        maxWidth: "500px",
        margin: "auto",
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
      }}>
        <h2 style={{ marginBottom: "10px" }}>RC PDF Generate</h2>

        <p style={{ color: "#666", marginBottom: "15px" }}>
          💰 Charge: <b style={{ color: "green" }}>₹100 per search</b>
        </p>

        <input
          type="text"
          placeholder="Enter RC Number (DL01AB1234)"
          value={rcno}
          onChange={(e) =>
            setRcno(e.target.value.toUpperCase().replace(/\s/g, ""))
          }
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            marginBottom: "15px"
          }}
        />

        <button
          onClick={handleGenerate}
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px",
            background: "linear-gradient(45deg, #007bff, #00c6ff)",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          {loading ? "Processing..." : "Generate RC"}
        </button>

        {loading && (
          <p style={{ marginTop: "10px", color: "orange" }}>
            Generating RC ⏳
          </p>
        )}

        {/* DOWNLOAD */}
        {pdfBase64 && (
          <button
            onClick={() => downloadPDF(pdfBase64, rcno)}
            style={{
              marginTop: "15px",
              width: "100%",
              padding: "10px",
              background: "#ff9800",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
             Download Latest RC
          </button>
        )}
      </div>

      {/* 🔥 HISTORY */}
      <div style={{
        maxWidth: "700px",
        margin: "30px auto",
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
      }}>
        <h3 style={{ marginBottom: "15px" }}>📄 RC History</h3>

        {history.length === 0 && <p>No records found</p>}

        {history.map((item, index) => (
          <div key={index} style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px",
            borderBottom: "1px solid #eee"
          }}>
            <div>
              <b>{item.rc_number}</b>
              <div style={{ fontSize: "12px", color: "#888" }}>
                ₹100 charged
              </div>
            </div>

            <button
              onClick={() =>
                downloadPDF(item.pdf_base64, item.rc_number)
              }
              style={{
                padding: "6px 12px",
                background: "#ff9800",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              DOWNLOAD 
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RCPdf2;